export default __webpack_public_path__ + "static/media/explosion.min.7b487aef.png";